import { NgClass, PercentPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'shared-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PercentPipe, NgClass],
})
export class ProgressBarComponent {
  @Input() progress = 0;
  @Input() color = '';
  @Input() styleClass = '';
  @Input() showTitle = false;
}
